import { render, staticRenderFns } from "./detail-tips.vue?vue&type=template&id=bbd72490&scoped=true"
import script from "./detail-tips.vue?vue&type=script&lang=js"
export * from "./detail-tips.vue?vue&type=script&lang=js"
import style0 from "./detail-tips.vue?vue&type=style&index=0&id=bbd72490&prod&scoped=true&lang=css"
import style1 from "./detail-tips.vue?vue&type=style&index=1&id=bbd72490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd72490",
  null
  
)

export default component.exports